export default __webpack_public_path__ + "static/target-b3f87cf67f5b6bd8a87e14b787f916b2.png";